var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconFeatherEye = function SvgIconFeatherEye(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fill: "#414a5f"
    },
    viewBox: "0 0 15.487 11.536",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.743 11.536c-4.862 0-7.577-5.318-7.69-5.544a.5.5 0 0 1 0-.447C.166 5.318 2.881 0 7.743 0c4.861 0 7.577 5.318 7.69 5.544.07.141.07.307 0 .447-.113.227-2.829 5.545-7.69 5.545M1.069 5.768c.553.971 2.957 4.769 6.674 4.769 3.716 0 6.119-3.796 6.674-4.768C13.862 4.796 11.459 1 7.743 1 4.017 1 1.621 4.796 1.069 5.768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.744 8.242a2.477 2.477 0 0 1-2.475-2.475 2.48 2.48 0 0 1 2.474-2.475h.001c.661 0 1.282.257 1.749.724s.726 1.089.726 1.75v.001a2.48 2.48 0 0 1-2.475 2.475m0-3.95c-.813 0-1.475.662-1.475 1.475s.662 1.475 1.475 1.475a1.477 1.477 0 0 0 1.043-2.518 1.46 1.46 0 0 0-1.043-.432"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconFeatherEye);
export default ForwardRef;